import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CustomerOverViewService} from '~features/customer-overview/customer-overview.service';
import {CustomerService, StorageService} from '~core/services';
import {CampaignStatus, Club, Customer} from '~core/models';
import {CampaignStatusTranslationsService, TooltipTranslationService} from '~shared/translations';

/**
 * Displays communication data inside of an info tile
 */
@UntilDestroy()
@Component({
  selector: '[app-communication-data-info]',
  templateUrl: './communication-data-info.component.html',
  styleUrls: ['../../../customer-overview.component.scss']
})
export class CommunicationDataInfoComponent {
  public spinnerLoading: boolean;
  public customer: Customer;
  public showCampaignStatus: boolean;
  public selectedClub: Club;

  @Input() public spinnerName: string;
  @Output() public fillCommunicationForm: EventEmitter<string> = new EventEmitter<string>();
  public campaignStatus: CampaignStatus;

  constructor(
    private campaignStatusTranslations: CampaignStatusTranslationsService,
    public tooltipTranslations: TooltipTranslationService,
    public customerOverviewService: CustomerOverViewService,
    public customerService: CustomerService,
    private storageService: StorageService
  ) {
    this.customerService.castSelectedCustomer.pipe(untilDestroyed(this)).subscribe((customer: Customer) => {
      this.customer = customer;
      this.initializeComponent();
      this.onCustomerChange();
    });
    this.storageService.castSelectedClub.pipe(untilDestroyed(this)).subscribe((club: Club) => {
      this.selectedClub = club;
      this.initializeComponent();
    });
  }


  public initializeComponent(): void {
    if (this.customer && this.selectedClub) {
      const customerStatusIsNull = this.customer.subscriptionStatus === null;
      this.showCampaignStatus = this.customer.hasEmail && !customerStatusIsNull;
      (this.selectedClub.isCampaignActive && !customerStatusIsNull) ? this.spinnerLoading = true : this.spinnerLoading = false;
    }
  }

  /**
   * Set new campaign status on customer change
   */
  public onCustomerChange(): void {
    this.campaignStatus = new CampaignStatus(this.customer.subscriptionStatus, this.campaignStatusTranslations);
    if (this.campaignStatus.status) {
      this.spinnerLoading = false;
    }
  }

  /**
   * Open the edit communication modal and fill the form.
   */
  public editCommunication(): any {
    this.customerOverviewService.toggleAllModal(false);
    this.fillCommunicationForm.emit('fill');
    this.customerOverviewService.toggleEditCommunicationModal(true);
  }

}
